module.exports = "<ngx-loading [show]=\"show\" [config]=\"config\"></ngx-loading>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = ./src/app/shared/spinner/spinner.component.html
// module chunks = main